import { MockRestCall } from "@/common/api/ApiResult.model";
import { RestCallsKey } from "@/mock/demo/rest.resolver";

// @ts-ignore
export const folders_context_labels: Record<
  Partial<RestCallsKey>,
  MockRestCall
> = {
  "folders-context-labels.create": {
    delay: 1000,
    payload: async () => {
      return true;
    },
  },
  "folders-context-labels.attach-to-folder": {
    delay: 1000,
    payload: async () => {
      return true;
    },
  },
};
